export const DEFAULT_CLIENT_FIELDS = Object.freeze({
  phone: true,
  email: false,
  company: true,
  notes: true,
  rating: true,
});

export const DEFAULT_OBJECT_FIELDS = Object.freeze({
  client: true,
  address: true,
  metro: true,
  contact_name: true,
  contact_phone: true,
  contact_email: false,
  work_hours: true,
  description: true,
  access_notes: true,
  systems: true,
  service: true,
});

const defaultsByGroup = {
  client_fields: DEFAULT_CLIENT_FIELDS,
  object_fields: DEFAULT_OBJECT_FIELDS,
};

export function normalizedProfileFields(settings, group) {
  const defaults = defaultsByGroup[group] || {};
  const saved = settings?.[group];
  return { ...defaults, ...(saved && typeof saved === 'object' ? saved : {}) };
}

export function phoneHref(value) {
  const phone = String(value || '').trim().replace(/[^\d+*#,;]/g, '');
  return phone ? `tel:${phone}` : null;
}

export function yandexMapsHref(address) {
  const value = String(address || '').trim();
  return value ? `https://yandex.ru/maps/?text=${encodeURIComponent(value)}` : null;
}
